import React from "react";
import logo from "../../../../assets/logo.png";
import telegram from "../../../../assets/telegram.png";
import twitter from "../../../../assets/twitter.png";
import { DesktopMainMenu,SiteLogo, MenuLink } from "../styles";

const DesktopMenu = (props) => {
 
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px">
        <SiteLogo src={logo} alt="Logo" />
      </MenuLink>
      <div style={{display:'flex'}}>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        
        <MenuLink href="https://t.me/peppererc20"  target="blank" className="social">
          <img src={telegram} alt="telegram" target="_blank" />
        </MenuLink>
        <MenuLink href="https://twitter.com/peppererc20"  target="blank" className="social">
          <img src={twitter} alt="twitter" target="_blank" />
        </MenuLink>
      </div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
